import { useDebouncedCallback } from 'use-debounce';

// A debounced text filter fires a full list request per burst of typing. 250ms suits
// most endpoints; a caller sitting on an expensive one (the Customers tab name search,
// where 250ms split normal typing into several requests, each re-running the whole
// query) passes a longer interval of its own rather than slowing every filter in the
// app down.
const DEFAULT_DEBOUNCE_MS = 250;

export default function useCasEnabledDebouncedCallback(
  callback: any,
  enabled?: boolean,
  ms: number = DEFAULT_DEBOUNCE_MS
) {
  const debounced = useDebouncedCallback(callback, enabled ? ms : 0);
  return debounced;
}
